const errorLog = {
	/**
	 * Will log the  error
	 * @error: error thrown
	 * @info: more info optional
	 */
	log: function (error, info) {
		console.log(error, info);
	},
};
export default errorLog;
